import React from 'react';
import TemplateProyect from '../TemplateProyect';

function Merry() {
    const infoTect = ["React", "HTML", "CSS", "JavaScript", "Particles.js", "", "", "", "", ""];
    const infoProyect = [
        "Merry Christmas",
        "https://www.youtube.com/embed/8bawSEKEkXY",
        "Christmas scene with snow particles",
        "https://brandongrimaldom.github.io/merry/",
        "/web-development"
    ];

    return (
        <React.Fragment>
            <TemplateProyect
                title={infoProyect[0]}
                video={infoProyect[1]}
                description={infoProyect[2]}
                github={infoProyect[3]}
                tecfilter={infoTect}
                after={infoProyect[4]}  >
            </TemplateProyect>
        </React.Fragment>
    );
}
export default Merry;